import request from '@/api/request.js'

// 新增
export function UserVSOrganizationInsert(data) {
    return request({
        url: '/api/user/uservsorganizationinsert',
        method: 'post',
        data: data
    })
}

// 新增
export function UserVSOrganizationInsertMany(data) {
    return request({
        url: '/api/user/uservsorganizationinsertmany',
        method: 'post',
        data: data
    })
}

// 删除
export function UserVSOrganizationDelete(id) {
    return request({
        url: `/api/user/uservsorganizationdelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function UserVSOrganizationUpdate(id, data) {
    return request({
        url: `/api/user/uservsorganizationupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function UserVSOrganizationGetById(id) {
    return request({
        url: `/api/user/getuservsorganizationbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function UserVSOrganizationGetList(params) {
    return request({
        url: '/api/user/getuservsorganizationlist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function UserVSOrganizationGetPageList(params) {
    return request({
        url: '/api/user/getuservsorganizationpagelist',
        method: 'get',
        params: params
    })
}